import { createContext } from 'react';
import { Streaming } from '@/contexts/streaming/types';

export const StreamingContext = createContext<Streaming>({} as Streaming);
StreamingContext.displayName = 'Streaming';
